import styled from 'styled-components'
import { useWorld } from './use-world'

const Container = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
`

const Dgt = styled.div``

export const Clock = () => {
  const { time } = useWorld()
  const pad = (n) => {
    return ('00' + n).slice(-2)
  }
  const getHour = (h) => {
    const hours = [
      '12',
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11'
    ]
    return hours[h]
  }
  const roundMinute = (m) => {
    return m < 15 ? 0 : m < 30 ? 15 : m < 45 ? 30 : 45
  }

  return (
    <Container>
      <Dgt>
        {getHour(time.hour)}:{pad(roundMinute(time.minute))}
      </Dgt>
    </Container>
  )
}
